import React, { useState, useEffect, useMemo, ChangeEvent } from 'react';
import { Collapse, Icon, version } from 'antd';
import { Widget, MasterDetailForm, Row, Table, ColumnProps, FormInput, Col, FormResetButton, Form, Button, FormatText } from '@digital/ui';
import {
    getAllContratoOrdemInvestimentoPlurianualByProjetoId,
    Projeto,
    ProjetoOrdemInvestimentoPlurianualTotalizador,
    ProjetoOrdemInvestimentoPlurianual
} from '../../api/projeto'
import { updateValorModuloAContratar, AContratar, atualizarTabelaADistribuirAContratar, verificarStatusDoProcessoDeAtualizacao } from '../../api/aContratar'
import CurrencyInput from '@app/components/CurrencyInput';
import { currencyFormat } from '../../helpers/numbers'
import { compareText } from '@app/helpers/comparators';
import { PaginationConfig } from 'antd/lib/pagination';
import LinkRequisitadoProjeto from '@app/components/linkRequisitadoProjeto';
import { notification } from '@digital/ui';
import ModalComentario from '../Projeto/ModalComentarioAContratar';

const { Panel } = Collapse;
interface PropFormAContratar {
    selectedItem: Projeto;
}

interface tipoColuna {
    colunaPrincipal: string,
    colunaSegundaria: string,
    valor: string,
    descricaoDataIndex: string,
};

const FormAContratar = (props: PropFormAContratar) => {

    const { selectedItem } = props;
    const [totalizador, setTotalizador] = useState<tipoColuna[]>();
    const [calcularTotal, seCalcularTotal] = useState<number>(0);
    const [projetoOrdemInvestimentoPlurianualTotalizadorResult, setProjetoOrdemInvestimentoPlurianualTotalizadorResult] = useState<ProjetoOrdemInvestimentoPlurianualTotalizador>();

    const saldoFormatado = "R$ 0,00";
    const saldoFormatado1 = 'R$0,00';

    // useMemo(() => {
    //     if (selectedItem) {
    //         getAllAContratarProjeto(selectedItem.id);
    //     }
    // }, [selectedItem]);

    useEffect(() => {
        if (selectedItem)
            getAllAContratarProjeto(selectedItem.id, false);
    }, [selectedItem])

    const getAllAContratarProjeto = (projetoId: string, atualizarTabela: boolean) => {

        if (atualizarTabela)
            notification.info("O sistema está atualizando as informações da tabela. O processo pode demorar alguns minutos.");

        getAllContratoOrdemInvestimentoPlurianualByProjetoId(projetoId, atualizarTabela)
            .then((resultProjetoOrdemInvestimentoPlurianualTotalizador) => {
                if (resultProjetoOrdemInvestimentoPlurianualTotalizador) {
                    resultProjetoOrdemInvestimentoPlurianualTotalizador.ordemInvestimento.map((ordemInvestimento) => {
                        const result = ordemInvestimento.children.filter((filho) => {
                            if (filho.tipoConsolidadoPlurianualCodigo === 4) {
                                return filho
                            } else {
                                if (filho.saldoFormatado != saldoFormatado && filho.saldoFormatado != saldoFormatado1) {
                                    return filho
                                }
                            }
                        });

                        let index = 1;
                        result.filter((pacote) => {
                            pacote.codigoPacote = index.toString();
                            index++;
                        });

                        ordemInvestimento.children = result;
                    });
                    setProjetoOrdemInvestimentoPlurianualTotalizadorResult(resultProjetoOrdemInvestimentoPlurianualTotalizador);
                }

            });
    }

    const alterarValor = (record: ProjetoOrdemInvestimentoPlurianual, e: number) => {
        if (projetoOrdemInvestimentoPlurianualTotalizadorResult) {
            let alteracaoRealizada = false;

            let novoOrdemInvestimento = projetoOrdemInvestimentoPlurianualTotalizadorResult.ordemInvestimento.filter((values) => {
                if (values.id == record.ordemInvestimentoId) {
                    values.children.filter((filho) => {
                        if (filho.tipoConsolidadoPlurianualCodigo === 4) {
                            filho.aContratar = e;
                            filho.saldo = e;
                            filho.saldoFormatado = currencyFormat(e);
                            filho.forcastFormatado = currencyFormat(e);
                            values.aContratarFormatado = currencyFormat(e);
                            alteracaoRealizada = true;
                        }
                    });
                }
                return values;
            });
            let total = 0;
            novoOrdemInvestimento.map((ordemInvestimento) => {
                ordemInvestimento.children.map((linhas) => {
                    total += linhas.saldo;
                });
            });

            seCalcularTotal(total);

            if (alteracaoRealizada) {
                const valorAlterado = { ordemInvestimentoId: record.ordemInvestimentoId, valor: e } as AContratar;
                updateValorModuloAContratar(valorAlterado).then((data) => {
                    if (data) {
                        const result = data as AContratar;
                        const novoTotalizador = {
                            totalColunaA: projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaA,
                            totalColunaB: projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaB,
                            totalColunaC: projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaC,
                            totalColunaD: projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaD,
                            totalColunaE: projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaE,
                            totalColunaF: result.totalFormatado,
                            totalColunaG: projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaG,
                            totalColunaH: currencyFormat(calcularTotal),
                            ordemInvestimento: novoOrdemInvestimento
                        } as ProjetoOrdemInvestimentoPlurianualTotalizador;
                        setProjetoOrdemInvestimentoPlurianualTotalizadorResult(novoTotalizador);
                    }
                });
            }
        }
    }


    useEffect(() => {
        if (projetoOrdemInvestimentoPlurianualTotalizadorResult) {
            let array = [
                {
                    colunaPrincipal: 'A',
                    colunaSegundaria: 'Orçado',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaA}`,
                    descricaoDataIndex: 'orcadoFormatado'
                },
                {
                    colunaPrincipal: 'B',
                    colunaSegundaria: 'Contratado',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaB}`,
                    descricaoDataIndex: 'contratadoFormatado'
                },
                {
                    colunaPrincipal: 'C',
                    colunaSegundaria: 'Executado',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaC}`,
                    descricaoDataIndex: 'executadoFormatado'
                },
                {
                    colunaPrincipal: 'D',
                    colunaSegundaria: 'Requisitado',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaD}`,
                    descricaoDataIndex: 'requisitadoFormatado'
                },
                {
                    colunaPrincipal: 'E = B - C + D',
                    colunaSegundaria: 'Compromissado',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaE}`,
                    descricaoDataIndex: 'compromissadoFormatado'
                },
                {
                    colunaPrincipal: 'F',
                    colunaSegundaria: 'A Contratar',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaF}`,
                    descricaoDataIndex: 'aContratarFormatado'
                },
                {
                    colunaPrincipal: 'G = B + D + F',
                    colunaSegundaria: 'Forecast',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaG}`,
                    descricaoDataIndex: 'forcastFormatado'
                },
                {
                    colunaPrincipal: 'H = A - G',
                    colunaSegundaria: 'Saldo',
                    valor: `${projetoOrdemInvestimentoPlurianualTotalizadorResult.totalColunaH}`,
                    descricaoDataIndex: 'saldoFormatado'
                },


            ] as tipoColuna[];
            setTotalizador(array);
        } else {
            setTotalizador([]);
        }
    }, [selectedItem, projetoOrdemInvestimentoPlurianualTotalizadorResult]);

    const gerarLinkRequisitado = (projetoId: any, record: any) => {
        if (record.requisitado != 0.00 && record.children === undefined) {
            return <LinkRequisitadoProjeto
                projetoId={projetoId}
                codigoPacote={record.ordemInvestimentoCodPacote}
                descricaoLink={record.requisitadoFormatado}
            />
        }
        return <> {record.requisitadoFormatado} </>
    }

    const collunsAContratar = useMemo(() => {
        if (totalizador) {
            let colluns: ColumnProps<any>[] = [
                {
                    title: 'N',
                    dataIndex: 'numeroLinha',
                },
                {
                    title: 'CÓDIGO',
                    dataIndex: 'codigoPacote',
                    sorter: (a, b) => compareText(a.codigoPacote, b.codigoPacote),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar CÓD. PROJETO"
                                    name="codigoPacote"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.codigoPacote !== undefined &&
                        record.codigoPacote
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'NOME PACOTE',
                    dataIndex: 'nomePacote',
                    sorter: (a, b) => compareText(a.nomePacote, b.nomePacote),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar NOME PACOTE"
                                    name="nomePacote"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.nomePacote !== undefined &&
                        record.nomePacote
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                }
            ];

            totalizador.map((tipoColuna) => {
                if (tipoColuna.colunaSegundaria === "Requisitado") {
                    colluns.push(
                        {
                            title: `${tipoColuna.valor}`,
                            children: [{
                                title: `${tipoColuna.colunaPrincipal}`,
                                children: [{
                                    title: `${tipoColuna.colunaSegundaria}`,
                                    dataIndex: `${tipoColuna.descricaoDataIndex}`,
                                    align: 'center',
                                    render: ((text, record) => {
                                        if (selectedItem)
                                            return gerarLinkRequisitado(selectedItem.id, record);
                                    })
                                }]
                            }]
                        }
                    );

                } else {
                    colluns.push(
                        {
                            title: `${tipoColuna.valor}`,
                            children: [{
                                title: `${tipoColuna.colunaPrincipal}`,
                                children: [{
                                    title: `${tipoColuna.colunaSegundaria}`,
                                    dataIndex: `${tipoColuna.descricaoDataIndex}`,
                                    align: 'center',
                                    render: ((text, record) => {
                                        if (tipoColuna.colunaPrincipal === 'F' && record.tipoConsolidadoPlurianualCodigo === 4) {
                                            return <>
                                                <CurrencyInput
                                                    id={`${record.id}_${'valor'}`}
                                                    name={`${record.id}_${'valor'}`}
                                                    value={record.aContratar}
                                                    onBlur={() => { }}
                                                    defaultValue={record.aContratar}
                                                    onChange={e => {
                                                        record.aContratar = e;
                                                    }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            alterarValor(record, record.aContratar);
                                                        }
                                                    }}
                                                />
                                            </>
                                        } else {
                                            return <> {record[tipoColuna.descricaoDataIndex]}</>
                                        }
                                    })
                                }]
                            }]
                        }
                    );
                }


            });

            colluns.push(
                {
                    title: 'COMENTARIOS',
                    dataIndex: 'comentarios',
                    align: 'center',
                    render: (text, record) => {
                        if (record.tipoConsolidadoPlurianualCodigo === 4) {
                            return <ModalComentario idLinha={record.id} />
                        } else {
                            return <> </>
                        }
                    }
                },
            )


            return colluns;
        }
        return [];
    }, [totalizador]);



    return (
        <>
            {totalizador
                && projetoOrdemInvestimentoPlurianualTotalizadorResult
                && projetoOrdemInvestimentoPlurianualTotalizadorResult.ordemInvestimento.length > 0 ? (
                <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                    <Panel key="1" header="A CONTRATAR PLURIANUAL" style={{ border: 0 }}>
                        <MasterDetailForm>
                            <Widget
                                actions={[
                                    <Button
                                        type="primary"
                                        name="btnAtualizarTabela"
                                        icon="ui-available_updates"
                                        onClick={() => {
                                            getAllAContratarProjeto(selectedItem.id, true)
                                        }}>
                                        <FormatText id="ui.commons.save" uppercase transform={() => "ATUALIZAR ACONTRATAR E ADISTRIBUIR"} />
                                    </Button>,
                                ]}>
                                <Row>
                                    <Table
                                        rowKey="id"
                                        id={'tabelaAContratar'}
                                        columns={collunsAContratar}
                                        dataSource={projetoOrdemInvestimentoPlurianualTotalizadorResult.ordemInvestimento}
                                        pagination={{
                                            pageSize: 10,
                                            onChange: (() => {
                                                document.getElementById("tabelaAContratar").scrollIntoView();
                                            })
                                        } as PaginationConfig}
                                    />
                                </Row>
                            </Widget>
                        </MasterDetailForm>
                    </Panel>
                </Collapse>

            ) : (<> </>)}

        </>);
}

export default FormAContratar;